/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InquirySourceDto } from '../models/InquirySourceDto';
import type { SuccessResponse } from '../models/SuccessResponse';
import type { UpgradeVoucherDto } from '../models/UpgradeVoucherDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DefaultService {

    /**
     * @param uuid
     * @returns any
     * @throws ApiError
     */
    public static pdfControllerRenderGiftcardPdf(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/giftcard/print-pdf/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param uuid
     * @returns any
     * @throws ApiError
     */
    public static pdfControllerDownloadGiftcardPdf(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/giftcard/download-pdf/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param pathname
     * @param filename
     * @returns any
     * @throws ApiError
     */
    public static pdfControllerDownloadGenericPdf(
        pathname: string,
        filename: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pdf-generation/{filename}/{pathname}',
            path: {
                'pathname': pathname,
                'filename': filename,
            },
        });
    }

    /**
     * @param requestBody
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static inquiryControllerSubmitInquirySource(
        requestBody: InquirySourceDto,
    ): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/inquiry-source',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns SuccessResponse
     * @throws ApiError
     */
    public static sibSyncControllerEnforceUpdate(): CancelablePromise<SuccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/newsletter/update/f2215654-ab89-11ec-b909',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static graphqlCacheControllerGraphqlEndpoint(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/graphql',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static indexControllerIndexAction(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static freebuyControllerFreeBuy(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/freebuy',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static stripeAboControllerCreateStripeSubscription(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe/subscription',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static stripeProductControllerCreateStripePaymentRequest(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe/product',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static braintreeAboControllerPaypalNonceHandler(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/braintree/subscription',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static braintreeProductControllerPaypalProductHandler(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/braintree/product',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static aboPremiumBraintreeControllerRenewPremium(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/braintree/renew-premium',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static aboPremiumStripeControllerRenewPremiumAbo(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe/renew-premium',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static voucherUpgradeBraintreeControllerCreateVoucherSubscription(
        requestBody: UpgradeVoucherDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/braintree/voucher-upgrade',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static voucherUpgradeStripeControllerCreateVoucherSubscription(
        requestBody: UpgradeVoucherDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe/voucher-upgrade',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static contentRecipeControllerGetRecipeList(): CancelablePromise<Array<any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/recipes/random',
        });
    }

    /**
     * @param category
     * @returns any
     * @throws ApiError
     */
    public static contentRecipeControllerGetRecipeListRandomByCategory(
        category: string,
    ): CancelablePromise<Array<any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/recipes/random/category/{category}',
            path: {
                'category': category,
            },
        });
    }

    /**
     * @param slug
     * @returns any
     * @throws ApiError
     */
    public static contentRecipeControllerGetRecipeDetailBySlug(
        slug: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/recipe/{slug}',
            path: {
                'slug': slug,
            },
        });
    }

    /**
     * @param strapiId
     * @returns any
     * @throws ApiError
     */
    public static contentRecipeControllerGetRecipeDetailByStrapiId(
        strapiId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/recipe/strapi/{strapiId}',
            path: {
                'strapiId': strapiId,
            },
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static contentRecipeControllerGetRecipesCategories(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/recipes/categories',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static contentRecipeControllerGetRecipesList(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/recipes',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static contentRecipeControllerSync(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/content/recipes/sync',
        });
    }

    /**
     * @param strapiId
     * @returns any
     * @throws ApiError
     */
    public static contentVideoControllerFetchAllMarksOf(
        strapiId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/videos/{strapiId}/spot-marks',
            path: {
                'strapiId': strapiId,
            },
        });
    }

    /**
     * @param tag
     * @returns any
     * @throws ApiError
     */
    public static contentCommonControllerFetchByTag(
        tag: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/common/{tag}',
            path: {
                'tag': tag,
            },
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static contentCommonControllerEnforceUpdate(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/content/update/1882cae8-3327-11ec-8d3d-0242ac130003',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static contentCourseControllerFetchSliderList(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/course/sliderList',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public static contentCourseControllerFetchSliderListWithVideos(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/course/sliderListWithVideos',
        });
    }

    /**
     * @param courseId
     * @returns any
     * @throws ApiError
     */
    public static contentCourseControllerFetchCourseSliderListForCourse(
        courseId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/course/sliderListForCourse/{courseId}',
            path: {
                'courseId': courseId,
            },
        });
    }

    /**
     * @param slug
     * @returns any
     * @throws ApiError
     */
    public static contentCourseControllerFetchCourseDetailBySlug(
        slug: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/course/courseDetailBySlug/{slug}',
            path: {
                'slug': slug,
            },
        });
    }

    /**
     * @param uuid
     * @returns any
     * @throws ApiError
     */
    public static contentCourseControllerFetchCourseDetailByUuid(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/content/course/courseDetailByUuid/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param uuid
     * @returns any
     * @throws ApiError
     */
    public static giftcardPrintControllerFetchDetailByUuid(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/giftcard/print/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }

    /**
     * @param pathname
     * @returns any
     * @throws ApiError
     */
    public static giftcardPrintControllerDownloadGiftcardPdf(
        pathname: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/giftcard/pdf-generation/{pathname}',
            path: {
                'pathname': pathname,
            },
        });
    }

}
